const USERS_TYPES = {
    GET_ALL_USERS: "GET_ALL_USERS",
    GET_ALL_USERS_LOADING: "GET_ALL_USERS_LOADING",
    GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
    GET_ALL_USERS_ERROR: "GET_ALL_USERS_ERROR",
    GET_ALL_USERS_RESET: "GET_ALL_USERS_RESET",

    GET_ALL_CATEGORY: "GET_ALL_CATEGORY",
    GET_ALL_CATEGORY_LOADING: "GET_ALL_CATEGORY_LOADING",
    GET_ALL_CATEGORY_SUCCESS: "GET_ALL_CATEGORY_SUCCESS",
    GET_ALL_CATEGORY_ERROR: "GET_ALL_CATEGORY_ERROR",
    GET_ALL_CATEGORY_RESET: "GET_ALL_CATEGORY_RESET",


    DELETE_USER: "GET_DELETE_USER",
    GET_DELETE_USER_LOADING: "GET_DELETE_USER_LOADING",
    GET_DELETE_USER_SUCCESS: "GET_DELETE_USER_SUCCESS",
    GET_DELETE_USER_ERROR: "GET_DELETE_USER_ERROR",
    GET_DELETE_USER_RESET: "GET_DELETE_USER_RESET",

    CREATE_USER: "CREATE_USER",
    CREATE_USER_LOADING: "CREATE_USER_LOADING",
    CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
    CREATE_USER_ERROR: "CREATE_USER_ERROR",
    CREATE_USER_RESET: "CREATE_USER_RESET",

    UPDATE_USER: "UPDATE_USER",
    UPDATE_USER_LOADING: "UPDATE_USER_LOADING",
    UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
    UPDATE_USER_ERROR: "UPDATE_USER_ERROR",
    UPDATE_USER_RESET: "UPDATE_USER_RESET",

    GET_ALL_ROLES: "GET_ALL_ROLES",
    GET_ALL_ROLES_LOADING: "GET_ALL_ROLES_LOADING",
    GET_ALL_ROLES_SUCCESS: "GET_ALL_ROLES_SUCCESS",
    GET_ALL_ROLES_ERROR: "GET_ALL_ROLES_ERROR",
    GET_ALL_ROLES_RESET: "GET_ALL_ROLES_RESET",

    GET_CSV_DATA: "GET_CSV_DATA",
    GET_CSV_DATA_LOADING: "GET_CSV_DATA_LOADING",
    GET_CSV_DATA_SUCCESS: "GET_CSV_DATA_SUCCESS",
    GET_CSV_DATA_ERROR: "GET_CSV_DATA_ERROR",
    GET_CSV_DATA_RESET: "GET_CSV_DATA_RESET",

    GET_USER_TASKS: "GET_USER_TASKS",
    GET_USER_TASKS_LOADING: "GET_USER_TASKS_LOADING",
    GET_USER_TASKS_SUCCESS: "GET_USER_TASKS_SUCCESS",
    GET_USER_TASKS_ERROR: "GET_USER_TASKS_ERROR",
    GET_USER_TASKS_RESET: "GET_USER_TASKS_RESET",

    GET_USER_BY_ID: "GET_USER_BY_ID",
    GET_USER_BY_ID_LOADING: "GET_USER_BY_ID_LOADING",
    GET_USER_BY_ID_SUCCESS: "GET_USER_BY_ID_SUCCESS",
    GET_USER_BY_ID_ERROR: "GET_USER_BY_ID_ERROR",
    GET_USER_BY_ID_RESET: "GET_USER_BY_ID_RESET",
}

export default USERS_TYPES